import React, {useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from 'react-router-dom';
import { UpdateUserHeaderSettings } from '../../../actions/UserSettingActions';
import ExcelDownload from './ExcelDownload';
import FieldSelect from './FieldSelect';
import useScreenSize from '../../../components/useScreenSize';
import updateUserFieldSettings from '../../../state/userSettingsSlice';
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional Theme applied to the Data Grid
import {
  BulkActionApprove,
  BulkActionApproveAll,
  BulkActionReject,
  BulkActionRejectAll,
  BulkActionDelete,
  BulkActionDeleteAll,
  BulkActionUnassign,
  BulkActionUnassignAll,
  BulkActionSendToImageReview,
  BulkActionSendToImageReviewAll,
  BulkActionChangeToReadyStatus,
  BulkActionChangeToReadyStatusAll,
  BulkActionMoveAndAssign,
  BulkActionMoveAndAssignAll,
  GetWorkflowStepsByBpId,
  BulkActionsDownload,
} from '../../../actions/BulkActions';
import ActiveDocumentStore from '../../../stores/ActiveDocumentStore';
import SearchStore from '../../../stores/SearchStore';


const DocumentList2 = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const gridRef = useRef(null);
    const colUpdate = useRef(null);
    const [allCheck, setAllCheck] = useState(false);
    const userInfo = useSelector(state => state.userInfo.value);
    //const screenSize = useSelector(state => state.screenSizeInfo.value);
    const [viewHeight, viewWidth] = useScreenSize();
    const userSettings = useSelector(state => state.userSettingInfo.value);
    const [downloadConfirmation, setDownloadConfirmation] = useState(false);
    const [showBulkMenu, setShowBulkMenu] = useState(false);
    const [showFieldSelect, setShowFieldSelect] = useState(false);
    const [showExcelExport, setShowExcelExport] = useState(false);
    const [showBulkApprove, setShowBulkApprove] = useState(false);
    const [showBulkReject, setShowBulkReject] = useState(false);
    const [selectedDocCount, setSelectedDocCount] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    //const [h, setH] = useState(window.innerHeight - 150);

    const idColCompare = (valueA, valueB, nodeA, nodeB, isDescending) => {

      return valueA.Id - valueB.Id
    };

    useEffect(() => {
      let myColDefs = [...props.colDefs];
      let idCol = myColDefs.find(d => d.field === 'Id');
      let idx = myColDefs.indexOf(idCol);
      let newIdCol = {...idCol};
      //newIdCol.lockPosition = 'left';
      newIdCol.pinned = 'left';
      newIdCol.cellRenderer = RowIdCell;
      myColDefs[idx] = newIdCol;
      newIdCol.comparator = idColCompare;
      setColDefs(myColDefs);
    }, [props.colDefs, props.fieldSettings])

    // useEffect(() => {
    //   setH(screenSize.sideBarHeight - 0);
    //   console.log(screenSize.sideBarHeight);
    // }, [screenSize]);

    const rowSelection = useMemo(() => {
      return {
            mode: 'multiRow',
            enableClickSelection: false,
            headerCheckbox: false,
            checkboxes: false,
        };
    }, []);

    const selectionColumnDef = useMemo(() => {
      return {
            width: 80,
            suppressHeaderMenuButton: false,
            suppressMovable: 'true',

        };
    }, []);


    const rowClick = (p, ev) => {
      console.log(p.data);

      if(ev.ctrlKey === true)
      {
        window.open(`/Document/${p.value.Id}`, '_blank');
      } else {
        navigate(`/Document/${p.data.Id.Id}`, {replace: false});
      }
    };

    const bulkActionClick = () => {

      console.log('bulk action clicking');
      if (showBulkMenu){
        removeCheckboxColumn();
      }
      else{
        addCheckboxColumn();
      }

      setShowBulkMenu(!showBulkMenu);
    };

    const RowIdCell = p => {
      return <>
      <div className='row flex-nowrap' onClick={(e) => rowClick(p, e)} style={{paddingLeft: '-1px', cursor: 'pointer'}}>

        {p.value.status === 0 &&
        <>
        <div className='col-auto col-ready m-0'>
          <i className='fa-solid fa-check' />
        </div>
        <div className='col-auto trans' style={{paddingLeft: '0px'}}>
        <svg width='8' height='36'>
          <polygon
            points='0,0 8,16, 0,32'
            fill='#3FAD42'
          />
        </svg>
        </div>
        </>
        }
        {p.value.status === 2 &&
        <>
        <div className='col-auto col-error m-0'>
          <i className='fa-regular fa-triangle-exclamation' />
        </div>
        <div className='col-auto trans' style={{paddingLeft: '0px'}}>
        <svg width='8' height='36'>
          <polygon
            points='0,0 8,16, 0,32'
            fill='#e73827'
          />
        </svg>
        </div>
        </>
        }
        {p.value.status === 1 &&
        <>
        <div className='col-auto col-lock m-0'>
          <i className='fa-solid fa-user-pen' /> {p.value.user}
        </div>
        <div className='col-auto trans' style={{paddingLeft: '0px'}}>
        <svg width='8' height='36'>
          <polygon
            points='0,0 8,16, 0,32'
            fill='#ddc562'
          />
        </svg>
        </div>
        </>
        }

        {p.value.Id}
      </div>
      </>;

    }

    const updateColumnSettings = (api) => {
      let settings = [];
        let defs = api.getColumnDefs();
        //console.log(defs);

        let i = 0;
        let hasChange = false;
        defs.forEach((def) => {

          if(userSettings.fieldSettings.formTypeId === props.formTypeId)
          {
            let col = userSettings.fieldSettings.columns[i];

            if(col.colName !== def.field && col.displayName !== def.headerName) hasChange = true;
            if(col.show === true && (def.hide === true)) hasChange = true;
            if(col.show === false && (def.hide === false || def.hide === undefined)) hasChange = true;
            if(col.colWidth !== def.width) hasChange = true;

            let colInfo = {};
            colInfo.colName = def.colId;
            colInfo.colWidth = def.width;
            colInfo.display = true;
            colInfo.sortDir = null;
            if(def.hide) colInfo.display = false;
            let col2 = userSettings.fieldSettings.columns.find(p => p.colName === def.field || p.colName === def.headerName);
            if(col2)
            {
              colInfo.fieldId = col2.fieldId;
            }
            settings.push(colInfo);
          }
          i++;

        });
        //console.log(settings);
        if(hasChange) {
          UpdateUserHeaderSettings(props.formTypeId, settings, dispatch);
        }
        //
    }

    const colWidthChange = (e) => {
      window.clearTimeout(colUpdate.current);
      colUpdate.current = window.setTimeout(() => updateColumnSettings(e.api), 1000);
    }

    const toggleFieldDisplay = (col) => {
      let sourceCols = [...props.colDefs];
      let curColDefs = [...colDefs];
      let fieldSetting = [...props.fieldSettings.columns];
        // remove a column.
        let colToRemove = curColDefs.find(f => f.field === col.colName || f.headerName === col.colName);
        if(colToRemove) {
          let idx = curColDefs.indexOf(colToRemove);
          colToRemove.hide = !col.show;
          curColDefs[idx] = colToRemove;
          setColDefs(curColDefs);
        }

    }


    const checkboxColumn = {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      pinned: 'left',
      lockedPosition: 'left',
      suppressMenu: true,
      lockPinned: true,
      field: '_checkbox',
      headerName: '',
      resizable: false,
      suppressSizeToFit: true,
      width: 50,
      maxWidth: 50,
      minWidth: 50,
    };

    const addCheckboxColumn =() => {
      setColDefs((prev) => {
        // avoid adding it twice
        if (prev.find((col) => col.field === '_checkbox')) return prev;
        return [checkboxColumn, ...prev];
      });
    };

    // Remove the checkbox column if present
    const removeCheckboxColumn = () => {
      setColDefs((prev) => prev.filter((col) => col.field !== '_checkbox'));
    };


    const [colDefs, setColDefs] = useState([
      { field: "Id",  lockPosition: 'left', pinned: 'left', cellRenderer: RowIdCell },
      { field: "Step" },
      { field: "Pages" },
      { field: "Queues" },
      { field: "Notes" },
      { field: "Related" },
    ]);


    const getFullSearchParams = () => {
      let p = props.getSearch();
      p.fullStep = true;

      let sortModel = gridRef.current.api.getColumnState();
      let sort = { id: "Id", sortDir: "asc" };
      if(sortModel.length > 0) {
        sortModel.forEach(sm => {
          if(sm.sort != null) {
            sort = { id: sm.colId, sortDir: sm.sort }
          }
        })
      }
      p.sortModel = sort;

      let filters = gridRef.current.api.getFilterModel();
      console.log(filters);

      console.log(Object.keys(filters));
      if(Object.keys(filters).length > 0)
      {
        let filterList = [];
        for(var key in filters) {
          let filterObj = filters[key];
          let filter = { fieldId: key, filterType: filterObj.filterType };
          if(filterObj.conditions !== undefined) {
            console.log('multi-condition');
            console.log(filterObj);
            filter.filterOperator = filterObj.operator;
            filter.conditions = [];
            filterObj.conditions.forEach(cond => {
              let filterparam = v.filterObj === undefined ? null : cond.filterObj.toString();
              filter.conditions.push({ filterValue: filterparam, filterType: cond.type })
            });
          } else {
            console.log('single-condition');
            console.log(filterObj);
            filter.conditions = [];
            filter.filterOperator = "";
            console.log(filterObj);
            let filterparam = filter.filterObj === undefined ? null : filter.filterObj.toString();
            filter.conditions.push({ filterValue: filterparam, filterType: filterObj.type });

          }
          filterList.push(filter);
          console.log(key);
          console.log();
        }
        console.log(filterList);
        p.filterModels = filterList;
      }

      return p;
    }
    const getSearchParams = () => {
      console.log('getSearch');
      let p = props.getSearch();
      p.fullStep = props.checkAll;

    let params = new URLSearchParams(window.location.search);
    var stepParam = params.get('Step');
    var bpParam = params.get('BP');
    p.stepId = parseInt(stepParam, 10);
    p.bpId = parseInt(bpParam, 10);
    if(!p.fullStep) {
      let docs = gridRef.current.api.getSelectedRows();
      console.log(docs);
      let docIds = [];
      docs.forEach((d) => {
        if (d.isChecked) {
          docIds.push(d.documentId);
        }
      });
      p.docs = docIds;
    } else {
      p.docs = [];
    }
    console.log(p);
    return p;
    }

    const toggleShowExcel = () => {
      let filters = gridRef.current.api.getFilterModel();
      let state = gridRef.current.api.getState();

      console.log(state);
      setShowExcelExport(!showExcelExport);
    }

    const onSelectionChange = () => {
      const allRows = gridRef.current.api.getDisplayedRowCount();
      const selectedRows = gridRef.current.api.getSelectedRows().length;
      setSelectedDocCount(selectedRows);
      setSelectedRows(gridRef.current.api.getSelectedRows());
      if(selectedRows === allRows) {
        setAllCheck(true);
      } else {
        setAllCheck(false);
      }
      const isSelectAllChecked = selectedRows === allRows;
    }


    const bulkApproveClick = () => {
      if (props.checkAll) {
        let query = ActiveDocumentStore.getRecentQuery();
        let params = SearchStore.getRecentParams();
        BulkActionApproveAll(query, params);
      } else {
        var selectedDocs = { docIds: [] };
        var rws = gridRef.current.api.getSelectedRows();

        selectedRows
          //.filter((filt) => filt.isChecked === true)
          .map((doc) =>
            selectedDocs.docIds.push({
              documentId: doc.Id.Id,
              stepId: props.stepId,
            })
          );

   
        //BulkActionApprove(selectedDocs);
      }

      //this.setState({ showBulkApprove: false });
      //this.setState({ showBulkResults: true });
      // this.setState({
      //   showBulkStatusMsg: 'Bulk Actions processing.  Please wait.',
      // });
      setShowBulkApprove(false);
      
    }


    const bulkRejectClick = () => {
      if (props.checkAll) {
        let query = ActiveDocumentStore.getRecentQuery();
        let params = SearchStore.getRecentParams();
        BulkActionRejectAll(query, params);
      } else {
        var selectedDocs = { docIds: [] };

       selectedRows
          //.filter((filt) => filt.isChecked === true)
          .map((doc) =>
            selectedDocs.docIds.push({
              documentId: doc.Id.Id,
              stepId: props.stepId,
            })
          );
        BulkActionReject(selectedDocs);
      }

      //this.setState({ showBulkApprove: false });
      //this.setState({ showBulkResults: true });
      // this.setState({
      //   showBulkStatusMsg: 'Bulk Actions processing.  Please wait.',
      // });


      setShowBulkReject(false);
      
    }



    return (
        <div
            className='d-flex flex-column flex-fill'
            style={{
            width: `${viewWidth-320}px`,
            height: `${viewHeight- 57}px`,
            position: 'relative'

            }}
        >
            <div
            className='d-flex '
            style={{
                background: '#EFEFEF',
                borderBottom: 'solid 1px #BBB',
                width: `${viewWidth -320}px`,
            }}
            >
                <div className='p-2 me-2'>
                    <strong>BP</strong>: {props.bpName}
                </div>
                {props.stepName !== undefined &&
                  <div className='p-2 me-2'>
                      <strong>Step</strong>: {props.stepName}
                  </div>
                }

                <div className='p-2 me-auto'>
                    <strong>Count</strong>: {props.docCount}
                </div>
                { showBulkMenu &&
                <div className='p-2 me-2'>
                    <strong>Checked Count</strong>:{' '}{selectedDocCount}
                </div>
                }

                <div
                    className='p-2 me-3'
                    style={{ cursor: 'pointer' }}
                    onClick={props.onRefresh}
                >
                    <i className='fa-solid fa-redo' /> Refresh
                </div>
                <div
                    className='p-2 me-3'
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggleShowExcel()}
                >
                    <i className='fa-regular fa-file-xls' /> Excel
                </div>
                <div  className='dropdown float-start' >
                <div
                  onClick={() => bulkActionClick()}
                  className='p-2 me-3'
                  style={{ cursor: 'pointer' }}
                >
                  <i className='fa-solid fa-list-ul' /> Bulk Actions


                    {showBulkMenu &&
                  <div id='bulkMenuDropdown' className='dropdown-content-bulk-menu bulk-menu-hide' >

                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowBulkApprove(true);
                        }}
                      >
                        <i
                          className='fa-solid fa-thumbs-up'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Approve
                      </div>


                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowBulkReject(true);
                        }}
                      >
                        <i
                          className='fa-solid fa-thumbs-down'
                          style={{ color: '#DF3E3E', marginRight: '8px' }}
                        />
                        Reject
                      </div>


                      <div
                        className='dropdown-menuitem'

                      >
                        <i
                          className='fa-solid fa-code-branch'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Change Business Process
                      </div>


                      <div
                        className='dropdown-menuitem'

                      >
                        <i
                          className='fa-solid fa-columns'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Change Readers
                      </div>


                      <div
                        className='dropdown-menuitem'

                      >
                        <i
                          className='fa-solid fa-check-circle'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Change to Ready Status
                      </div>


                      <div
                        className='dropdown-menuitem'

                      >
                        <i
                          className='fa-solid fa-remove'
                          style={{ color: '#EC4B4B', marginRight: '8px' }}
                        />
                        Delete
                      </div>


                      <div
                        className='dropdown-menuitem'

                      >
                        <i
                          className='fa-solid fa-exchange'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Move & Assign
                      </div>


                      <div
                        className='dropdown-menuitem'

                      >
                        <i
                          className='fa-solid fa-file-pdf'
                          style={{ color: '#AE4BCF', marginRight: '8px' }}
                        />
                        Send To Image Review
                      </div>

                      <div
                        className='dropdown-menuitem'

                      >
                        <i
                          className='fa-solid fa-backspace'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Unassign
                      </div>


                      <div
                        className='dropdown-menuitem'

                      >
                        <i
                          className='fa-solid fa-download'
                          style={{ color: '#D20707', marginRight: '8px' }}
                        />
                        Download
                      </div>

                    <div
                      className='dropdown-menuitem'
                      onClick={() => setShowBulkMenu(false)}
                    >
                      <i
                        className='fa-solid fa-external-link-alt'
                        style={{ color: '#38C158', marginRight: '8px' }}
                      />
                      Exit Bulk Actions
                    </div>
                  </div>
                    }

                </div>
                </div>
                <div
                    className='p-2 me-3'
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowFieldSelect(true)}

                >
                    <i className='fa-regular fa-table-columns' /> Fields
                </div>
            </div>
            <div
         className="ag-theme-alpine" // applying the Data Grid theme
         style={{ height: viewHeight }} // the Data Grid will fill the size of the parent container
        >
            <AgGridReact
                rowHeight={36}
                ref={gridRef}
                rowData={props.rowData}
                columnDefs={colDefs}
                pagination={false}
                rowSelection={showBulkMenu ? rowSelection : null}
                selectionColumnDef={selectionColumnDef}
                onColumnResized = {(e) => colWidthChange(e)}
                onColumnMoved = {(e) => colWidthChange(e)}
                onDisplayedColumnsChanged = {(e) => colWidthChange(e)}
                onSelectionChanged = {onSelectionChange}
            />
            </div>
            {showExcelExport &&
              <ExcelDownload
                close={() => toggleShowExcel()}
                getSearch={getFullSearchParams}
                mode={props.mode}
                formTypeId={props.formTypeId}
              ></ExcelDownload>
            }
            {showFieldSelect &&
              <FieldSelect
                close={()=> setShowFieldSelect(false)}
                columnSettings={props.fieldSettings}
                toggleFieldDisplay={toggleFieldDisplay}
                formTypeId={props.formTypeId}
              ></FieldSelect>
            }

            {showBulkApprove && (
              <div className='td-dialogue-container'>
                <div
                  className='td-dialogue card'
                  style={{ height: '600px', width: '600px' }}
                >
                  <div className='card-header'>
                    Bulk Approve
                    <button
                      onClick={() => setShowBulkApprove(false)}
                      className='btn-close'
                    />
                  </div>
                  <div className='card-body'>
                    <div className='form-check  mt-2'>
                      <label className='form-check-label'>
                        {props.checkAll && (
                          <>{this.props.docCount} document(s) will be approved</>
                        )}
                        {!props.checkAll && (
                          <>{selectedDocCount} document(s) will be approved</>
                        )}
                      </label>
                    </div>
                    <button
                      onClick={() => bulkApproveClick()}
                      className='btn btn-success mt-3 w-100'
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* {showBulkReject && (
              <BulkRejectDlg
                  close={this.toggleBulkReject}
                  docs={this.getBulkDocs}
                  getSearch={this.getSearchParams}
                  visible={this.showBulkReject}
                />
            )} */}

            {showBulkReject && (
              <div className='td-dialogue-container'>
                <div
                  className='td-dialogue card'
                  style={{ height: '600px', width: '600px' }}
                >
                  <div className='card-header'>
                    Bulk Reject
                    <button
                      onClick={() => setShowBulkReject(false)}
                      className='btn-close'
                    />
                  </div>
                  <div className='card-body'>
                    <div className='form-check  mt-2'>
                      <label className='form-check-label'>
                        {props.checkAll && (
                          <>{props.docCount} document(s) will be rejected</>
                        )}
                        {!props.checkAll && (
                          <>{selectedDocCount} document(s) will be rejected</>
                        )}
                      </label>
                    </div>
                    <button
                      onClick={() => bulkRejectClick()}
                      className='btn btn-success mt-3 w-100'
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            )}

        </div>
    );
}

export default DocumentList2;
